(function () {
  'use strict';

  function createMobilePurchaseBar(win, bar) {
    const doc = win.document;
    const section = bar.closest('.shopify-section') || doc;
    const original = section.querySelector('#add-to-cart');
    const form = original && original.closest('form[action*="/cart/add"]');
    const wrapper = original && original.closest('[data-variant-selected]');
    const action = bar.querySelector('[data-mobile-purchase-action]');
    const size = bar.querySelector('[data-mobile-purchase-size]');
    const sizeLabel = bar.querySelector('[data-mobile-purchase-size-label]');
    const price = bar.querySelector('[data-mobile-purchase-price]');
    const comparePrice = bar.querySelector('[data-mobile-purchase-compare-price]');
    const sourcePrice = section.querySelector('.ProductMeta__PriceList .igPrice');
    const sizes = form && form.querySelector('[id^="ProductFormSize-"]');
    if (!original || !form || !wrapper || !action || !sizes || !sourcePrice) return { destroy() {} };

    let variants;
    try { variants = JSON.parse(bar.querySelector('[data-mobile-purchase-variants]').textContent); }
    catch (_) { return { destroy() {} }; }
    const mobile = win.matchMedia('(max-width: 767px)');
    const reduced = win.matchMedia('(prefers-reduced-motion: reduce)');
    // Product info has a transform; place fixed UI outside its containing block.
    bar.mobilePurchaseSource = section;
    doc.body.appendChild(bar);
    let destroyed = false, frame = 0, fitFinderOpen = false, clickUntil = 0, unlockTimer;
    const listeners = [];
    function listen(target, event, fn, options) {
      target.addEventListener(event, fn, options);
      listeners.push(() => target.removeEventListener(event, fn, options));
    }
    function text(node, value) { if (node.textContent !== value) node.textContent = value; }
    function visible(node) {
      if (node.hidden || node.getAttribute('aria-hidden') === 'true') return false;
      const style = win.getComputedStyle(node);
      return style.visibility !== 'hidden' && style.display !== 'none' && node.getClientRects().length > 0;
    }
    function overlayOpen() {
      return fitFinderOpen || Array.from(doc.querySelectorAll('.Drawer[aria-hidden="false"], .Modal[aria-hidden="false"], .Popover[aria-hidden="false"], [role="dialog"][aria-modal="true"]')).some(visible);
    }
    function current() {
      const field = form.querySelector('[name="id"]');
      const variant = field && variants[String(field.value)];
      const selected = wrapper.getAttribute('data-variant-selected') === 'true';
      const busy = original.getAttribute('aria-busy') === 'true' || original.classList.contains('is-adding') || original.classList.contains('is-loading');
      return { variant, selected, busy, disabled: original.disabled };
    }
    function update() {
      frame = 0;
      if (destroyed) return;
      const state = current();
      const rect = original.getBoundingClientRect();
      const show = mobile.matches && rect.width > 0 && rect.bottom < 0 && !overlayOpen();
      bar.hidden = !show;
      doc.body.classList.toggle('has-mobile-purchase-bar', show);
      if (!show) return;
      text(price, sourcePrice.textContent.trim());
      if (comparePrice) {
        const sourceCompare = section.querySelector('.ProductMeta__PriceList .igComparePrice');
        const showCompare = sourceCompare && visible(sourceCompare) && sourceCompare.textContent.trim();
        comparePrice.hidden = !showCompare;
        text(comparePrice, showCompare ? sourceCompare.textContent.trim() : '');
      }
      size.hidden = !state.selected;
      const checked = sizes.querySelector('input[type="radio"]:checked');
      const selectedName = checked ? checked.value : state.variant && state.variant.title;
      text(sizeLabel, state.selected && selectedName ? 'Size ' + selectedName : '');
      const sizeName = state.selected && selectedName ? 'Change selected size, ' + selectedName : 'Choose size';
      if (size.getAttribute('aria-label') !== sizeName) size.setAttribute('aria-label', sizeName);
      const label = state.busy ? 'Adding…' : state.selected ? (original.querySelector('[data-add-to-cart-label]') || original).textContent.trim() : 'Choose size';
      text(action, label);
      action.disabled = state.busy || (state.selected && state.disabled) || Date.now() < clickUntil;
      action.setAttribute('aria-busy', state.busy ? 'true' : 'false');
      const height = Math.ceil(bar.getBoundingClientRect().height) + 'px';
      if (doc.body.style.getPropertyValue('--mobile-purchase-bar-height') !== height) doc.body.style.setProperty('--mobile-purchase-bar-height', height);
    }
    function schedule() { if (!destroyed && !frame) frame = win.requestAnimationFrame(update); }
    function chooseSize() {
      sizes.scrollIntoView({ block: 'center', behavior: reduced.matches ? 'auto' : 'smooth' });
      const focus = sizes.querySelector('input[type="radio"]:checked') || sizes.querySelector('input[type="radio"]:not([disabled])') || sizes.querySelector('select,button');
      if (focus) focus.focus({ preventScroll: true });
    }
    listen(size, 'click', chooseSize);
    listen(action, 'click', () => {
      const state = current();
      if (!state.selected) { chooseSize(); return; }
      if (state.busy || state.disabled || Date.now() < clickUntil) return;
      // The original button owns validation, properties, one add and drawer opening.
      clickUntil = Date.now() + 1000;
      original.click();
      update();
      win.clearTimeout(unlockTimer);
      unlockTimer = win.setTimeout(schedule, 1010);
    });
    listen(win, 'scroll', schedule, { passive: true });
    listen(win, 'resize', schedule);
    listen(doc, 'change', schedule);
    for (const event of ['variant:change', 'variant:changed', 'product:variant-change', 'product:added', 'cart:updated']) listen(doc, event, schedule);
    listen(doc, 'vw-open', () => { fitFinderOpen = true; schedule(); });
    listen(doc, 'vw-close', () => { fitFinderOpen = false; schedule(); });
    const observer = new win.MutationObserver(records => {
      if (records.some(record => !bar.contains(record.target) && !(record.target === doc.body && record.type === 'attributes'))) schedule();
    });
    observer.observe(doc.documentElement, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['aria-hidden', 'hidden', 'aria-busy', 'disabled', 'data-variant-selected', 'class'] });
    listen(win, 'pageshow', schedule);
    update();
    return { update, destroy() {
      destroyed = true;
      observer.disconnect();
      listeners.forEach(remove => remove());
      win.cancelAnimationFrame(frame);
      win.clearTimeout(unlockTimer);
      bar.hidden = true;
      doc.body.classList.remove('has-mobile-purchase-bar');
      doc.body.style.removeProperty('--mobile-purchase-bar-height');
      bar.remove();
    } };
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = { createMobilePurchaseBar };
  if (typeof window !== 'undefined') {
    const initialise = () => document.querySelectorAll('[data-mobile-purchase-bar]').forEach(bar => {
      if (!bar.mobilePurchaseController) bar.mobilePurchaseController = createMobilePurchaseBar(window, bar);
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
    else initialise();
    document.addEventListener('shopify:section:load', initialise);
    document.addEventListener('shopify:section:unload', event => document.querySelectorAll('[data-mobile-purchase-bar]').forEach(bar => {
      if (bar.mobilePurchaseController && event.target.contains(bar.mobilePurchaseSource)) bar.mobilePurchaseController.destroy();
    }));
  }
})();
